import { GenericCollectionFactory } from "../_generics";
import { HostifyListing } from "../_modelsTS/Integration";

export const HostifyStore = GenericCollectionFactory<HostifyListing>("HOSTIFY-INTEGRATION", "id");